<!-- Modal -->
<div id="myModal" class="modal fade show" role="dialog" [ngStyle]="{'display':display}">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-left">{{dialogTitle}}</h5>
        <button (click)="onClose()" type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body" *ngIf="questions">
        <!-- <app-dialog-slide-panel [activePane]="isShowHistory ? 'right' : 'left'">
          <div leftPane>
            <app-dialog-slide-panel [activePane]="isLeftVisible ? 'left' : 'right'">
              <div leftPane>
                
                <div class="d-flex">
                  <h6 style="margin-bottom: 15px;color:#000;">{{questions.length}} questions</h6>
                  <div class="ml-auto">
                    <a (click)="onShowHistory()" class="link" href="javascript:;">View History</a>
                  </div>
                </div>
                <p>{{instruction}}</p>
                <app-quiz-item [maxIndex]="questions.length" (onNextCallback)="moveNext()"
                  (onPreviousCallback)="movePrevious()" (onSubmitCallback)="onSubmit()" [question]="currentQuestion"
                  [index]="currentIndex"></app-quiz-item>
              </div>
              <div rightPane>
                <app-quiz-result (onRetryCallback)="onRetryQuiz()" [score]="resultScore"></app-quiz-result>
              </div>

            </app-dialog-slide-panel>
          </div>
          <div rightPane>
            <app-quiz-history [startGetData]="isShowHistory" [lessonId]="lessonId" (onBackCallback)="onHideHistory()"></app-quiz-history>
          </div>
        </app-dialog-slide-panel> -->
        <div class="container" *ngIf="isLeftVisible && !isShowHistory">
          <div class="lesson-toolbar row">
            <!-- Top row -->
            <div class="lesson-toolbar-top">

              <!-- Questions -->
              <div class="question-count">
                <div>
                  <span class="count-number">
                    {{ questions.length }}
                  </span>

                  <span class="count-text">
                    Questions
                  </span>
                </div>
              </div>

              <!-- History -->
              <a
                *ngIf="showHistoryButton"
                (click)="onShowHistory()"
                href="javascript:;"
                class="history-btn"
              >
                <i class="fa fa-history"></i>
                <span>View History</span>
              </a>

            </div>


            <!-- Audio -->
            <div
              *ngIf="audioSource"
              class="audio-player-box"
            >
              <audio
                #quizAudio
                controls
                [src]="audioSource"
                preload="metadata"
              ></audio>
            </div>

          </div>
          <div class="row">
              <div [innerHTML]="senitizeHtmlContent(instruction)"></div>
              <app-quiz-item [maxIndex]="questions.length" (onNextCallback)="moveNext()"
                (onPreviousCallback)="movePrevious()" (onSubmitCallback)="onSubmit()" [question]="currentQuestion"
                [index]="currentIndex"></app-quiz-item>
          </div>
        </div>

        <div class="container" *ngIf="!isLeftVisible">
            <app-quiz-result (onRetryCallback)="onRetryQuiz()" (onShuffleCallBack)="onShuffleQuiz()" [questions]="questions" [score]="resultScore"></app-quiz-result>
        </div>

        <div class="containter" *ngIf="isShowHistory">
            <app-quiz-history [startGetData]="isShowHistory" [lessonId]="lessonId" (onBackCallback)="onHideHistory()"></app-quiz-history>
        </div>


      </div>
      
    </div>

  </div>
</div>